<template>
  <div>
    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("centerpurpose") }}</h4>
        </div>
      </div>
    </div>


    <!--content start-->
    <div id="purpose">
      <div class="grab">
        <img src="/static/img/purpose_img.jpg">
        <!--<p style="margin-top: 24px">{{ $t("centerpurpose_detail_1") }}</p>-->
        <!--<p>{{ $t("centerpurpose_detail_2") }}</p>-->
        <!--<p>{{ $t("centerpurpose_detail_3") }}</p>-->
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'CenterPurpose'
  }
</script>



// WEBPACK FOOTER //
// src/components/CenterPurpose.vue